import { render, staticRenderFns } from "./searchTagList.vue?vue&type=template&id=11c20de8&scoped=true&"
import script from "./searchTagList.vue?vue&type=script&lang=js&"
export * from "./searchTagList.vue?vue&type=script&lang=js&"
import style0 from "./searchTagList.vue?vue&type=style&index=0&id=11c20de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c20de8",
  null
  
)

export default component.exports